import React from 'react'

const Exchanges = () : JSX.Element => {
  return (
    <div> To Get Data for this component requires me to pay for the data </div>
  )
}

export default Exchanges